import { Check } from '@chain-zen/ui'

import type { TTMSAppSource } from '../../../types/tracking'
import { TMSAppIcon } from '../provider-icons/tms-app-icon'
import { TrackingSourceRow } from '../tracking-source-row'
import { TrackingTimeDisplay } from '../tracking-time-display'

interface ITMSAppInfoProps {
  shipmentID: string
  trackingSourceData: TTMSAppSource
}

/**
 * Displays the details for TMS App location source
 */
export const TMSAppInfo = (props: ITMSAppInfoProps) => {
  const { trackingSourceData } = props
  const lastLocation =
    trackingSourceData?.locations && trackingSourceData.locations.length > 0
      ? trackingSourceData.locations[trackingSourceData.locations.length - 1]
      : null

  return (
    <TrackingSourceRow className="px-2">
      <div className="flex items-center gap-1 flex-wrap">
        <Check className="h-3 w-3 shrink-0 self-center text-green-500 dark:text-green-400" />
        <TMSAppIcon size={3} />
        <span className="text-sm font-medium text-foreground">
          Tracking sent by {trackingSourceData.sourceDisplayName || 'TMS App'} via API
        </span>
        {!!lastLocation && (
          <TrackingTimeDisplay
            className="flex items-center gap-1 text-xs text-muted-foreground"
            filterReason={trackingSourceData.filterReason}
            lastLocationCity={lastLocation.city}
            lastLocationFetchedAt={trackingSourceData.lastLocationFetchedAt}
            lastLocationStateCode={lastLocation.stateCode}
            lastLocationTimestamp={lastLocation.timestamp}
            wrapper="div"
          />
        )}
      </div>
    </TrackingSourceRow>
  )
}
